let selectConfig: SelectConfig = {
    selectType: 0
};

export default selectConfig;
